/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_ReadyInputs */

const en_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to put it to work?`)
};

const es_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para ponerlo en práctica?`)
};

const de_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit, es in die Tat umzusetzen?`)
};

const zh_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好投入使用了吗？`)
};

const ar_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستعد لتطبيقه؟`)
};

const fr_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à le mettre en œuvre ?`)
};

const vi_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng áp dụng?`)
};

const sw_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je, uko tayari kuifanyia kazi?`)
};

const th_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พร้อมที่จะนำไปใช้งานหรือยัง?`)
};

const bs_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremni da to primijenite?`)
};

const ja_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実践に移す準備はできましたか？`)
};

const ko_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이제 실전에 적용해 볼까요?`)
};

const pt_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto para trabalhar?`)
};

const it_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto a metterlo al lavoro?`)
};

const sv_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo att sätta den på jobbet?`)
};

const nl_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar om te werken?`)
};

const da_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er du klar til at arbejde?`)
};

const nb_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til å gjøre det til jobb?`)
};

const fi_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oletko valmis?`)
};

const pl_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowy do pracy?`)
};

const ru_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готовы заставить его работать?`)
};

const tr_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunu çalışmaya hazır mısın?`)
};

const hi_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसे काम करने के लिए तैयार?`)
};

const id_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap untuk bekerja?`)
};

const ms_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedia untuk mempraktikkannya?`)
};

const cs_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravena to zprovoznit?`)
};

const el_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έτοιμος για δουλειά;`)
};

const he_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוכנים לשים את זה לעבודה?`)
};

const af_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gereed om dit toe te pas?`)
};

const hu_method_ready = /** @type {(inputs: Method_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Készen állsz, hogy működjön?`)
};

/**
* | output |
* | --- |
* | "Ready to put it to work?" |
*
* @param {Method_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_ready = /** @type {((inputs?: Method_ReadyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_ReadyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_ready(inputs)
	if (locale === "de") return de_method_ready(inputs)
	if (locale === "zh") return zh_method_ready(inputs)
	if (locale === "ar") return ar_method_ready(inputs)
	if (locale === "fr") return fr_method_ready(inputs)
	if (locale === "vi") return vi_method_ready(inputs)
	if (locale === "sw") return sw_method_ready(inputs)
	if (locale === "th") return th_method_ready(inputs)
	if (locale === "bs") return bs_method_ready(inputs)
	if (locale === "ja") return ja_method_ready(inputs)
	if (locale === "ko") return ko_method_ready(inputs)
	if (locale === "pt") return pt_method_ready(inputs)
	if (locale === "it") return it_method_ready(inputs)
	if (locale === "sv") return sv_method_ready(inputs)
	if (locale === "nl") return nl_method_ready(inputs)
	if (locale === "da") return da_method_ready(inputs)
	if (locale === "nb") return nb_method_ready(inputs)
	if (locale === "fi") return fi_method_ready(inputs)
	if (locale === "pl") return pl_method_ready(inputs)
	if (locale === "ru") return ru_method_ready(inputs)
	if (locale === "tr") return tr_method_ready(inputs)
	if (locale === "hi") return hi_method_ready(inputs)
	if (locale === "id") return id_method_ready(inputs)
	if (locale === "ms") return ms_method_ready(inputs)
	if (locale === "cs") return cs_method_ready(inputs)
	if (locale === "el") return el_method_ready(inputs)
	if (locale === "he") return he_method_ready(inputs)
	if (locale === "af") return af_method_ready(inputs)
	if (locale === "hu") return hu_method_ready(inputs)
	return en_method_ready(inputs)
});